import React, { useState, useEffect } from 'react';
import { 
  Modal, 
  Typography, 
  TextField,  
  Button,
  Box,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { FluxButton } from '@meltwater/flux-web-components-react';
import apiServiceCompany from '../../services/company.services';
import { AlertTrackingService } from '../../services/alerttracking.service';
import styles from './sendgrid.module.css';

const Addtracking = ({reload}) => {
  const [companyData, setCompanyData] = useState(null);
  const [errormessage, setErrormessage] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [userInput, setUserInput] = useState('');
  
  const handleInputChange = (event) => {
    setUserInput(event.target.value);
  };
  
  const handleClick = () => {
    setOpenModal(true);
  };

  const handleClose = async () => {
    setOpenModal(false);
    setCompanyData(null);
    setCompanyId(null);
    setUserInput('');
    setErrormessage(null);
  };

  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        console.log("lookup ", companyId);
        const response = await apiServiceCompany.getCompany(companyId);
        console.log("response.data", response);
        if (response.status === 'ok') {
          setCompanyData(response.data);
        } else {
          setErrormessage(response.data);
        }
      } catch (error) {
        console.error('Error fetching company data:', error);
        setErrormessage(error.message);
      }
    };
    
    if (companyId != null) {
      fetchCompanyData();
    }
  }, [companyId]);

  const handleSave = async () => {
    console.log('Company data saved:', companyData);
    const result = await AlertTrackingService.addCompany(companyData._id, companyData.name);
    console.log("HERE:", result);
    if (result[0].data.status === "ok") {
      setOpenModal(false);
      setCompanyData(null);
      setCompanyId(null);
      setUserInput('');
      setErrormessage(null);
      reload(true);
    } else {
      setErrormessage(result.data);
    }
  };
  
  const handleCancel = () => {
    setCompanyId(null);
    setCompanyData(null);
  };
  
  return (
    <>
      <FluxButton onClick={handleClick} type='filled' tint='primary'>Add Company</FluxButton>
      <Modal open={openModal} onClose={handleClose}>
        <div className={styles.bootstrapModal}>
          {/* Modal Header */}
          <div className={styles.bootstrapModalHeader}>
            <Typography variant="h6" component="h2">
              {companyData ? "Confirm Company Tracking" : "Add Company to Track"}
            </Typography>
            <IconButton 
              edge="end" 
              color="inherit" 
              onClick={handleClose} 
              aria-label="close"
              size="small"
            >
              <CloseIcon />
            </IconButton>
          </div>
          
          {/* Modal Body */}
          <div className={styles.bootstrapModalBody}>
            {companyData ? (
              <>
                <Typography variant="body1" gutterBottom>
                  Do you want to track this company?
                </Typography>
                <Box 
                  sx={{ 
                    p: 2, 
                    my: 2, 
                    border: '1px solid #e0e0e0', 
                    borderRadius: '4px',
                    bgcolor: '#f5f5f5' 
                  }}
                >
                  <Typography variant="h6">
                    {companyData.name} ({companyData._id})
                  </Typography>
                </Box>
              </>
            ) : (
              <>
                <Typography variant="body1" gutterBottom>
                  Enter the Company ID to start tracking
                </Typography>
                
                <TextField 
                  fullWidth 
                  placeholder="Enter Company ID" 
                  value={userInput} 
                  onChange={handleInputChange}
                  variant="outlined"
                  sx={{ mt: 2 }}
                  error={Boolean(errormessage)}
                  helperText={errormessage}
                />
              </>
            )}
          </div>
          
          {/* Modal Footer */}
          <div className={styles.bootstrapModalFooter}>
            {companyData ? (
              <>
                <Button 
                  variant="outlined" 
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
                <Button 
                  variant="contained" 
                  style={{ backgroundColor: '#188182', color: '#FFFFFF' }}
                  onClick={handleSave}
                >
                  Track
                </Button>
              </>
            ) : (
              <>
                <Button 
                  variant="outlined" 
                  onClick={handleClose}
                >
                  Close
                </Button>
                <Button 
                  variant="contained" 
                  style={{ backgroundColor: '#188182', color: '#FFFFFF' }}
                  onClick={() => setCompanyId(userInput)}
                  disabled={!userInput}
                >
                  Load
                </Button>
              </>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Addtracking;
